<mat-drawer-container
  class="form-sidenav-container"
  autosize
  [style]="getFormWidthAndHeight()"
>
  <mat-drawer #drawer class="form-sidenav" mode="side" opened>
    <ng-content select=".form-slot"></ng-content>
  </mat-drawer>
  <mat-drawer-content #drawerContent>
    <div class="header-content-right-sidenav-container" style="display: flex">
      <div
        class="header-content-container"
        [style.width]="toolHeaderWidthPct + '%'"
      >
        <div class="tool-header-container">
          <button
            *ngIf="shouldShowToggleBtn"
            style="display: inline"
            type="button"
            mat-button
            (click)="toggleMatDrawer(drawer)"
          >
            <mat-icon
              [matTooltip]="
                filterState === 'close' ? 'Open filters' : 'Close filters'
              "
              *ngIf="!isMobileView"
              >{{
                filterState === 'close' ? 'filter_alt' : 'filter_alt_off'
              }}</mat-icon
            >
            <mat-icon *ngIf="isMobileView">filter_alt</mat-icon>
          </button>
          <ng-content select=".tool-header"></ng-content>
        </div>
        <ng-content select=".main-content"></ng-content>
      </div>
      <ng-content select=".right-sidenav"></ng-content>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
